// Feature flags configuration
export interface FeatureFlag {
  enabled: boolean;
  description: string;
}

export interface FeatureFlags {
  [key: string]: FeatureFlag;
}

const features: FeatureFlags = {
  globalCdn: {
    enabled: true,
    description: 'Global CDN feature for content delivery',
  },
  performance: {
    enabled: true,
    description: 'Performance optimization features',
  },
  security: {
    enabled: true,
    description: 'Security features and protections',
  },
  aiSolutions: {
    enabled: true,
    description: 'AI-powered solutions and features',
  },
  development: {
    enabled: true,
    description: 'Development tools and features',
  },
  analytics: {
    enabled: true,
    description: 'Analytics and reporting features',
  },
  accessControl: {
    enabled: true,
    description: 'Access control and permissions',
  },
  realtime: {
    enabled: true,
    description: 'Real-time features and updates',
  },
  pricingPage: {
    enabled: true, 
    description: 'Pricing page visibility and access',
  },
  teamSection: {
    enabled: false,
    description: 'Our team section visibility on about page',
  },
  companiesSection: {
    enabled: false,
    description: 'Companies/brands logos section visibility',
  },
  footerSocialIcons: {
    enabled: false,
    description: 'Social media icons visibility in the footer',
  }
};

export const isFeatureEnabled = (featureName: string): boolean => {
  return features[featureName]?.enabled ?? false;
};

export default features; 